import cn from 'classnames';
import { Heading, Picture } from '@petsmart-ui/sparky';
import { propsImageItems } from '../../utils/propsImagesItems';
import { cutText } from '../../utils/cutText';

import type { CampaignHeroVariantProps } from './types';
import './CampaignHeroMd.scss';

export default function CampaignHeroMd({ header, image, primaryTextColor }: CampaignHeroVariantProps) {
    const imageItems = propsImageItems(image);

    return (
        <div
            className={cn('campaign-hero-md', {
                'campaign-hero-md__grey': primaryTextColor === 'Dark Grey',
                'campaign-hero-md__red': primaryTextColor === 'Dark Grey w/ Red',
            })}
        >
            <Picture imgAlt={image.webAltText} imgSrc={imageItems[0]?.srcSet} items={imageItems} />

            <Heading tagName="h2">{cutText(header, 20)}</Heading>
        </div>
    );
}
